import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 60px;
  padding: 40px 0;
  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};

  color: ${({ theme }) => theme.colors.neutral.white};

  ${media.greaterThan("medium")`
    width: 1024px;
    margin: 0 auto;
    max-width: 1300px;
  `};
`;

export const Register = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 40px;

  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};

  color: ${({ theme }) => theme.colors.neutral.white};
`;

export const PersonalForm = styled.div`
  display: grid;
  grid-template-areas:
    "full_name full_name document document"
    "responsible_name responsible_name responsible_name responsible_name"
    "email email phone phone"
    "password password confirm_password confirm_password";
  gap: 20px;

  ${media.lessThan("medium")`
    display: flex;
    flex-direction: column;
  `}
`;

export const PasswordForm = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  ${media.lessThan("medium")`
    display: flex;
    flex-direction: column;
  `}
`;

export const CommunicationOptin = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  align-items: flex-start;
  justify-content: flex-end;
  width: 100%;

  label {
    max-width: 100% !important;
  }

  ${media.lessThan("medium")`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  `}
`;

export const DataGridForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  ${media.lessThan("medium")`
    display: flex;
    flex-direction: column;
  `}
`;

export const Optins = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;

  label {
    max-width: 100% !important;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
  }

  a {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    color: ${({ theme }) => theme.colors.neutral.white};
    text-decoration: underline;
  }

  ${media.lessThan("medium")`
    display: flex;
    flex-direction: column;
  `}
`;

export const Buttons = styled.div`
  padding-top: 40px;
  display: flex;
  justify-content: flex-end;
  gap: 20px;

  width: 100%;
`;
